import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@sr/ui-library';
import { Control } from 'react-hook-form';
import * as yup from 'yup';
import { CountryCombobox } from '../../shared/CountryCombobox';
import { WORKSPACE_DETAILS_FORM_FIELDS } from '../../shared/fieldNames';
import { WorkspaceDetailsFormValues } from '../../shared/types';

interface TaxResidencyFieldProps {
  control: Control<WorkspaceDetailsFormValues>;
}

export const TaxResidencyField = ({ control }: TaxResidencyFieldProps) => (
  <FormField
    name={WORKSPACE_DETAILS_FORM_FIELDS.taxResidency}
    control={control}
    render={({ field }) => (
      <FormItem>
        <FormLabel asterisk tooltipContent="Residency for tax purposes">
          Tax Residency
        </FormLabel>
        <FormControl>
          <CountryCombobox
            field={field}
            placeholder="Select a tax residency country"
          />
        </FormControl>
        <FormMessage />
      </FormItem>
    )}
  />
);

TaxResidencyField.schema = yup
  .string()
  .when(['businessNumberCountry', 'entityType'], {
    is: (businessNumberCountry: string, entityType: string) =>
      !!businessNumberCountry && !!entityType,
    otherwise: (schema) => schema.nullable(),
    then: (schema) => schema.required('Please select a Tax Residency'),
  });
